import {AbstractBCMProvider} from './abstract';
import {MaterialUnit as MaterialUnitModel} from '../model';
import {MANAGEMENT, PROVIDER} from '../../../resources/bcmApi';

export class MaterialUnit extends AbstractBCMProvider {
  management = MANAGEMENT.MATERIAL;
  model = new MaterialUnitModel();
  name = PROVIDER.MATERIAL_UNITS;
}
